export default __webpack_public_path__ + "static/media/cupHolding.02545131.png";